// @ts-check

import { api } from '@/api'

/**
 * @returns {Promise<AccountingPeriod[]>}
 */
export const getAccountingPeriods = async () => {
  const res = await api.get('accounting-periods')
  return res.data
}

/**
 * @returns {Promise<import('axios').AxiosResponse<VatPeriod[]>>}
 */
export const getVatPeriods = () => api.get('vat-periods')

/**
 * @returns {Promise<AttachmentResource>}
 */
export const getIncomeStatementReport = async (
  startDate = null,
  endDate = null,
  lang = null,
  download = null,
  dimension = null,
  tag = null
) =>
  api.get(`reports/income-statement-report`, {
    params: {
      start_date: startDate,
      end_date: endDate,
      lang,
      download: download ? 1 : 0,
      dimension: dimension ?? null,
      tag: tag ?? null
    }
  })

export const getBalanceSheetReport = async (
  startDate = null,
  endDate = null,
  lang = null,
  download = null,
  dimension = null,
  tag = null
) =>
  api.get(`reports/balance-sheet-report`, {
    params: {
      start_date: startDate,
      end_date: endDate,
      lang,
      download: download ? 1 : 0,
      dimension: dimension ?? null,
      tag: tag ?? null
    }
  })

/**
 * Fetches vat report for a vat period with the given id.
 * @param {number} vatPeriodId
 * @returns {Promise<FileResource>}
 */
export const getVatReport = async (vatPeriodId) =>
  api.get(`vat-periods/${vatPeriodId}/report`)

export const getGeneralJournalReport = async (
  startDate = null,
  endDate = null
) =>
  api.get(`reports/general-journal`, {
    params: {
      start_date: startDate,
      end_date: endDate
    }
  })
